import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function MedCartInspectionMethodologyPage() {
  return (
    <CustomerMethodologyPage
      title="Medication cart inspection — overview"
      description="How WeConsult Rx supports structured medication cart inspections with photo evidence and corrective action tracking."
      path="/trust/med-cart-inspection-methodology"
    >
      <p>
        The medication cart inspection workflow guides consultant pharmacists
        through a structured checklist with photo evidence, deficiency tracking,
        and corrective action follow-up.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Standardized inspection checklists per facility.</li>
        <li>Photo evidence attached to specific checklist items.</li>
        <li>Corrective action assignment and completion tracking.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Inspections produce an auditable record suitable for facility QAPI
        meetings and surveyor review — without paper forms or email chains.
      </p>
    </CustomerMethodologyPage>
  );
}
